import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { DocumentService } from '../app/services/document.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentLoadedGuard implements CanActivate {
  constructor(private documentService: DocumentService, private router: Router) {}

  canActivate(): boolean {
    if (this.documentService.getDocument()) {
      return true;
    } else {
      this.router.navigate(['/upload']);
      return false;
    }
  }
}
